import React from 'react';


interface IResponseOptionsTab {
    handleTabClick: (activeTab: string) => void
    activeTab: string
}

export const ResponseOptionsTab = ({handleTabClick, activeTab}: IResponseOptionsTab) => {
    return (
        <div className="test-tabs-box">
            <span className="text">Ответы</span>
            <div className="test-tabs-nav">
                    <span
                        className={`tab-nav-item ${activeTab === 'inForm' ? 'active' : ''}`}
                        onClick={() => handleTabClick('inForm')}>
                            В форме
                    </span>
                <span className={`tab-nav-item ${activeTab === 'text' ? 'active' : ''}`}
                      onClick={() => handleTabClick('text')}>
                            Текстом
                </span>
            </div>
        </div>
    );
};

